enum EFinanceTypes {
  'LEASING' = 'leasing',
  'PURCHASE' = 'purchase',
}

export default EFinanceTypes;
